import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { SETTING_DATA_TYPES } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * list Data Type.
 * @returns {Promise} - A promise that resolves with the list of Data Type or rejects with an error.
 * @param props
 */
export const listDataTypes = async ({
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${SETTING_DATA_TYPES}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    dataTypes: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Data Type.
 * @returns {Promise} - A promise that resolves with the creation of integration type or rejects with an error.
 * @param data
 */
export const createDataType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${SETTING_DATA_TYPES}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Data Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const updateDataType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${SETTING_DATA_TYPES}/${data?.DataType}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Delete Data Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const deleteDataType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${SETTING_DATA_TYPES}/${data?.DataType}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Get Data Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const getDataType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${SETTING_DATA_TYPES}/${data?.DataType}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
